import Dashboard from "./pages/dashboard/dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Allpost from "./components/dashboard/allpost";
import AddNewPost from "./components/dashboard/addNewPosts";
import EditPost from "./components/dashboard/editPost";
import LoginPage from "./pages/login";
import ProtectedRoute from "./components/protectedRoutes";
import HomePage from "./pages/HomePage";
import "./style.css";
import Profile from "./components/dashboard/profile";
import ReviewsPage from "./components/dashboard/reviews";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<HomePage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<Allpost />} />
            <Route path="allposts" element={<Allpost />} />
            <Route path="addNewPost" element={<AddNewPost />} />
            <Route path="editPost/:id" element={<EditPost />} />
            <Route path="profile" element={<Profile />} />
            <Route path="reviews" element={<ReviewsPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
